import ControlTowerSite from 'core/entities/ControlTowerEntities/ControlTowerSiteObject';

class ControlTowerObject {
    constructor (data) {
        if (data) {
            this.count = data.count;
            this.sites = data.sites.map(site => new ControlTowerSite(site));
        }
    }
}

export default ControlTowerObject;
